import { render, staticRenderFns } from "./DashboardAside.vue?vue&type=template&id=73151c2e&scoped=true"
import script from "./DashboardAside.vue?vue&type=script&lang=js"
export * from "./DashboardAside.vue?vue&type=script&lang=js"
import style0 from "./DashboardAside.vue?vue&type=style&index=0&id=73151c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73151c2e",
  null
  
)

export default component.exports